const InputPlaceholder  = (props) => {
    return(
        <div className="input_placeholder">{props.label}</div>
    )
}
export default InputPlaceholder;